import localStorage from 'local-storage';
import { sortBy, prop, pipe, sort } from 'ramda';
import { useState } from 'react';
import ideas from './ideas';

const App = () => {
  const [isNewShown, setIsNewShown] = useState(false);
  const [isFreezedShown, setIsFreezedShown] = useState(false);
  const [idsToDates, setIdsToDates] = useState(localStorage('idsToDates') as any || {});
  const [idsToFreezed, setIdsToFreezed] = useState(localStorage('idsToFreezed') as any || {});
  const now = Date.now();
  const isSpentDays = (date: Date, days: number) => (now - +date) / (1000 * 60 * 60 * 24) + (days < 1 ? days : 1)/8 > days;
  const mappedIdeas = ideas
    .map(idea => {
      const lastDate = idsToDates[idea.id] && new Date(idsToDates[idea.id]);
      const isFreezed = idsToFreezed[idea.id];
      return {
        ...idea,
        lastDate,
        isFreezed,
        isWarned: lastDate ? isSpentDays(lastDate, idea.daysToWarn) : null,
        isAlerted: lastDate ? isSpentDays(lastDate, idea.daysToAlert) : null,
      };
    })
    .filter(({ isFreezed }) => isFreezedShown || !isFreezed);
  return (
    <div className="app">
      <button onClick={() => setIsNewShown(!isNewShown)}>{isNewShown ? 'Скрыть' : 'Показать'} новые дела</button>
      <button onClick={() => setIsFreezedShown(!isFreezedShown)}>{isFreezedShown ? 'Скрыть' : 'Показать'} замороженные дела</button>
      <ul>
        {[
          ...(isNewShown ? pipe(
            sortBy(prop('title')),
          )(mappedIdeas.filter(({ id }) => !idsToDates[id])) : []),
          ...pipe(
            sort(({ lastDate: a }: any, { lastDate: b }: any) => !a && b ? -1 : 1),
            sortBy(prop('lastDate')),
            sort((a, b) => (
              (a.isAlerted && !b.isAlerted) ||
              (a.isWarned && !b.isWarned) ||
              (a.isAlerted && b.isAlerted && a.daysToAlert < b.daysToAlert)
            ) ? -1 : 1),
          )(mappedIdeas.filter(({ id }) => idsToDates[id])),
        ]
          .map(({ id, title, url, lastDate, isWarned, isAlerted, isFreezed }) => (
            <li key={id}>
              <span className="title">{url ? (<a href={url} target="_blank" rel="noreferrer">{title}</a>) : title}</span>
              <span className="button" onClick={() => {
                const newIdsToDates = {
                  ...idsToDates,
                  [id]: new Date(),
                };
                localStorage('idsToDates', newIdsToDates);
                setIdsToDates(newIdsToDates);
              }}>✔</span>
              <span className={`button ${isFreezed && 'active'}`} onClick={() => {
                const newIdsToFreezed = {
                  ...idsToFreezed,
                  [id]: !isFreezed,
                };
                localStorage('idsToFreezed', newIdsToFreezed);
                setIdsToFreezed(newIdsToFreezed);
              }}>❄</span>
              {lastDate && (<span className={`date ${isAlerted ? 'alert' : isWarned ? 'warning' : ''}`}>{lastDate?.toLocaleString()}</span>)}
            </li>
          ))
        }
      </ul>
    </div>
  );
}

export default App;
